import { pluralizeEntityTypes as p } from "./index.es263.js";
import _ from "qs";
const $ = (a) => ({
  entity_id: i,
  entity_type: t,
  mode: s,
  size: r,
  within_distance: e,
  start_date: n,
  end_date: o
}) => {
  const d = Math.max(1, Math.floor(r)), y = e ? Math.max(1, Math.floor(e)) : void 0, c = _.stringify({
    mode: s,
    size: d,
    within_distance: y,
    start_date: n,
    end_date: o
  });
  return a.post(
    `/${p[t]}/${i}/polygon?${c}`,
    {}
  );
}, T = (a) => ({
  entity_id: i,
  entity_type: t,
  size: s,
  start_date: r,
  end_date: e,
  geoid_type: n
}) => {
  const o = _.stringify({
    geoid_type: n,
    size: s,
    start_date: r,
    end_date: e
  });
  return a.post(
    `/${p[t]}/${i}/cbgs?${o}`,
    {}
  );
}, m = (a) => ({
  entity_id: i,
  entity_type: t,
  size: s,
  start_date: r,
  end_date: e,
  geoid_type: n
}) => {
  const o = _.stringify({
    geoid_type: n,
    tta_percentage: s,
    start_date: r,
    end_date: e
  });
  return a.get(
    `/${p[t]}/${i}/cbgs?${o}`,
    {}
  );
}, u = (a) => ({
  poiId: i,
  poiType: t,
  startDate: s,
  endDate: r,
  tradeAreaType: e = "TTA",
  size: n = 70,
  withinDistance: o = 50
}) => {
  const d = _.stringify({
    start_date: s,
    end_date: r,
    mode: e,
    size: n,
    alloc: "weighted_centroid",
    template_id: "default",
    ...e === "TTA" && { within_distance: o },
    weight_by: "population"
  });
  return a.post(
    `/${p[t]}/${i}/census2022/stats?${d}`,
    {}
  );
}, h = (a) => ({
  poiId: i,
  poiType: t,
  startDate: s,
  endDate: r,
  size: e = 70,
  template: n = "overview",
  withinDistance: o = 50,
  tradeAreaType: d = "TTA"
}) => {
  const y = _.stringify({
    start_date: s,
    end_date: r,
    mode: d,
    size: e,
    alloc: "weighted_centroid",
    template_id: n,
    ...d === "TTA" && { within_distance: o },
    weight_by: "population"
  });
  return a.post(
    `/${p[t]}/${i}/mosaic/stats?${y}`,
    {}
  );
}, w = (a) => ({
  poiId: i,
  poiType: t,
  startDate: s,
  endDate: r,
  size: e = 70,
  template: n = "default",
  withinDistance: o = 50,
  tradeAreaType: d = "TTA"
}) => {
  const y = _.stringify({
    start_date: s,
    end_date: r,
    mode: d,
    size: e,
    alloc: "weighted_centroid",
    template_id: n,
    ...d === "TTA" && { within_distance: o },
    weight_by: "population"
  });
  return a.post(
    `/${p[t]}/${i}/popstats/stats?${y}`,
    {}
  );
}, D = (a) => ({
  poiId: i,
  poiType: t,
  startDate: s,
  endDate: r,
  size: e = 70,
  template: n = "overview",
  withinDistance: o = 50,
  tradeAreaType: d = "TTA"
}) => {
  const y = _.stringify({
    start_date: s,
    end_date: r,
    mode: d,
    size: e,
    alloc: "weighted_centroid",
    template_id: n,
    ...d === "TTA" && { within_distance: o },
    weight_by: "population"
  });
  return a.post(
    `/${p[t]}/${i}/spatial_ai_personalive/stats?${y}`,
    {}
  );
}, f = (a) => ({ poiId: i, poiType: t, startDate: s, endDate: r }) => {
  const e = _.stringify({
    start_date: s,
    end_date: r,
    collection: p[t],
    years: 1
  }), n = {
    where: {
      audience_sector: ["any_resident"]
    }
  };
  return a.post(
    `/${p[t]}/${i}/market-pop/overview?${e}`,
    n
  );
}, A = (a) => ({ poiId: i, poiType: t, startDate: s, endDate: r }) => {
  const e = _.stringify({
    start_date: s,
    end_date: r,
    collection: p[t],
    years: 1
  }), n = {
    where: {
      audience_sector: ["any_resident"]
    }
  };
  return a.post(
    `/${p[t]}/${i}/market-pop/employees?${e}`,
    n
  );
}, v = (a) => ({ poiId: i, poiType: t, startDate: s, endDate: r, dataset: e, flavor: n }) => {
  const o = {
    report: {
      start_date: s,
      end_date: r,
      custom_filter: {
        where: {
          audience_sector: [
            "inbound_visitor",
            "resident_worker",
            "inbound_worker",
            "any_resident"
          ]
        }
      }
    },
    flavor: n,
    demographics: {
      plugin_id: e,
      template_id: "default"
    }
  };
  return a.post(
    `/v1/${p[t]}/${i}/market/stats`,
    o
  );
};
export {
  u as getCensusData,
  T as getGeoTradeAreaCbgs,
  m as getGeoTradeAreaChainCbgs,
  $ as getGeoTradeAreaPolygon,
  A as getMarketPopEmployees,
  f as getMarketPopulation,
  v as getMarketStats,
  h as getMosaicData,
  D as getPersonaLiveData,
  w as getPopstatsData
};
//# sourceMappingURL=index.es493.js.map
